import { Button } from "reactstrap";

export default function RadioGroup({
  id,
  options,
  isSelected,
  getSelected,
  setSelected,
}) {
  const getLabel = (option) =>
    option.abbrLabel && "" !== option.abbrLabel
      ? option.abbrLabel
      : option.label;

  const changeHandler = (event) => {
    const { name, value } = event.target;
    // console.log(
    //   `RadioGroup changeHandler() name: ${name}, value ${value}`
    // );
    setSelected(name, [value]);
  };

  const clearHandler = () => {
    // console.log(`clearHandler(${id})`);
    setSelected(id, []);
  };

  return (
    <>
      <br />
      <span>
        {options.map((opt) => (
          <label key={opt.id} className="prompt-option">
            <input
              type="radio"
              className="prompt-radio-btn"
              name={id}
              value={opt.id}
              checked={isSelected(id, opt.id)}
              onChange={changeHandler}
            />
            {getLabel(opt)}
          </label>
        ))}
        <Button
          color="primary"
          size="sm"
          outline={true}
          onClick={clearHandler}
          className="clear-radio-btn"
        >
          Clear
        </Button>
      </span>
    </>
  );
}
